import { Layout, LayoutContainer, Page, useAppConfig, usePath } from "@fdoh/health-ui-react";
import { DataTable, Select2 } from "@fdoh/health-react";
import { useEffect, useRef, useState } from "react";
import {Link, useHistory,  useLocation } from "react-router-dom";
import useData from "../../hooks/useData";
import useClient from "../../hooks/useInspectionClient";
import { Row } from "@fdoh/health-react";
import IconEdit from "../../icons/IconEdit";
import { Columns, UserList } from "./UserManagement.types";
import useProfile from "../../hooks/useProfile";
import { UserSecurityInput } from "../../components/DBProtectedRoute.types";







export const UserManagementPage = () => {
  const history = useHistory();
    const path = usePath();
     
    const config = useAppConfig();
    const application = config.applications.filter(x => x.name === "privateProviderInspectionApi")[0];
    const user =  useProfile(application) as UserSecurityInput;
    let userList= useData<UserList[]>('UserSecurity/getlistofactiveusers' );
    
    
  
    
    
    return (
      <Page.Container>
      <LayoutContainer>
                  <div className="county-grid">
                
                    <Row className="mt-4">
                  <DataTable
                      name="Userlist"
                      columns={Columns}
                      data={userList!=undefined?userList:[]}
                      title="Active User List"                
                      globalFilter
                      striped
                      vcenter
                       />
                       </Row>
    </div>
          </LayoutContainer>
  </Page.Container>
    ); <div>
    
  </div>;
};

export default UserManagementPage;